import * as type from "../types/overview";

const initialState = {
  activeSelectionYear: null,
  activeRangeType: null,
  filters: {
    sales: null,
    responses: null,
    clients: null,
    scoreboard: null,
    deliveries: null,
  },
  fetchResponses: {
    status: [],
    loading: true,
    error: null,
  },
  fetchSales: {
    status: [],
    loading: true,
    error: null,
  },
  fetchClients: {
    status: [],
    loading: true,
    error: null,
  },
  fetchDeliveries: {
    status: [],
    loading: true,
    error: null,
  },
  fetchRevenue: {
    status: [],
    loading: true,
    error: null,
  },
  fetchGoals: {
    status: null,
    loading: true,
    error: null,
    type: null,
  },
  addGoal: {
    status: null,
    loading: false,
    error: null,
  },
  updateGoal: {
    status: null,
    loading: false,
    error: null,
  },
  deleteGoal: {
    status: null,
    loading: false,
    error: null,
  },
  activeUpdateGoal: {
    amount: null,
    start: null,
    end: null,
  },
  selectionYears: {
    status: null,
    loading: true,
    error: null,
  },
  showModals: {
    rangeModal: false,
    addGoalModal: false,
    editGoalModal: false,
  },
};

export const overview = (state = initialState, payload) => {
  switch (payload.type) {
    case type.SET_FILTER_TYPE:
      if (payload.info.type === "responses") {
        return {
          ...state,
          filters: {
            ...state.filters,
            responses: payload.info.filter,
          },
        };
      } else if (payload.info.type === "clients") {
        return {
          ...state,
          filters: {
            ...state.filters,
            clients: payload.info.filter,
          },
        };
      } else if (payload.info.type === "sales") {
        return {
          ...state,
          filters: {
            ...state.filters,
            sales: payload.info.filter,
          },
        };
      } else if (payload.info.type === "scoreboard") {
        return {
          ...state,
          filters: {
            ...state.filters,
            scoreboard: payload.info.filter,
          },
        };
      } else if (payload.info.type === "deliveries") {
        return {
          ...state,
          filters: {
            ...state.filters,
            deliveries: payload.info.filter,
          },
        };
      } else {
        return state;
      }
    case type.CHANGE_OVERVIEW_MODALS:
      if (
        payload.modal.rangeModal === true ||
        payload.modal.rangeModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            rangeModal: payload.modal.rangeModal,
          },
        };
      } else if (
        payload.modal.addGoalModal === true ||
        payload.modal.addGoalModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addGoalModal: payload.modal.addGoalModal,
          },
        };
      } else if (
        payload.modal.editGoalModal === true ||
        payload.modal.editGoalModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editGoalModal: payload.modal.editGoalModal,
          },
        };
      } else {
        return state;
      }
    case type.SET_ACTIVE_RANGE_TYPE:
      return {
        ...state,
        activeRangeType: payload.payload,
      };
    case type.RESET_ACTIVE_RANGE_TYPE:
      return {
        ...state,
        activeRangeType: null,
      };
    case type.REQUEST_RESPONSE_DATA:
      return {
        ...state,
        fetchResponses: {
          ...state.fetchResponses,
          status: [],
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_RESPONSE_DATA:
      return {
        ...state,
        fetchResponses: {
          ...state.fetchResponses,
          status: [0, 0, 0],
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_RESPONSE_DATA:
      return {
        ...state,
        fetchResponses: {
          ...state.fetchResponses,
          status: payload.content,
          loading: false,
          error: null,
        },
      };
    case type.RESET_RESPONSE_DATA:
      return {
        ...state,
        fetchResponses: {
          ...state.fetchResponses,
          status: [0, 0, 0],
          loading: false,
          error: null,
        },
      };
    /***/
    case type.REQUEST_SALES_DATA:
      return {
        ...state,
        fetchSales: {
          ...state.fetchSales,
          status: [],
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_SALES_DATA:
      return {
        ...state,
        fetchSales: {
          ...state.fetchSales,
          status: [],
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_SALES_DATA:
      return {
        ...state,
        fetchSales: {
          ...state.fetchSales,
          status: payload.content,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SALES_DATA:
      return {
        ...state,
        fetchSales: {
          ...state.fetchSales,
          status: [],
          loading: false,
          error: null,
        },
      };
    /** */
    case type.REQUEST_REVENUE_DATA:
      return {
        ...state,
        fetchRevenue: {
          ...state.fetchRevenue,
          status: [],
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_REVENUE_DATA:
      return {
        ...state,
        fetchRevenue: {
          ...state.fetchRevenue,
          status: [0, 0, 0],
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_REVENUE_DATA:
      return {
        ...state,
        fetchRevenue: {
          ...state.fetchRevenue,
          status: payload.content,
          loading: false,
          error: null,
        },
      };
    case type.RESET_REVENUE_DATA:
      return {
        ...state,
        fetchRevenue: {
          ...state.fetchRevenue,
          status: [],
          loading: false,
          error: null,
        },
      };
    /* */
    case type.REQUEST_CLIENTS_DATA:
      return {
        ...state,
        fetchClients: {
          ...state.fetchClients,
          status: [],
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_CLIENTS_DATA:
      return {
        ...state,
        fetchClients: {
          ...state.fetchClients,
          status: [],
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_CLIENTS_DATA:
      return {
        ...state,
        fetchClients: {
          ...state.fetchClients,
          status: payload.content,
          loading: false,
          error: null,
        },
      };
    case type.RESET_CLIENTS_DATA:
      return {
        ...state,
        fetchClients: {
          ...state.fetchClients,
          status: [],
          loading: false,
          error: null,
        },
      };
    /* */
    case type.REQUEST_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: payload.content,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: null,
          loading: false,
          error: null,
        },
      };
    /* */
    case type.SET_ACTIVE_SELECTION_YEAR:
      return {
        ...state,
        activeSelectionYear: payload.year,
      };
    case type.RESET_ACTIVE_SELECTION_YEAR:
      return {
        ...state,
        activeSelectionYear: null,
      };
    /* */
    case type.REQUEST_DELIVERIES_DATA:
      return {
        ...state,
        fetchDeliveries: {
          ...state.fetchDeliveries,
          status: [],
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELIVERIES_DATA:
      return {
        ...state,
        fetchDeliveries: {
          ...state.fetchDeliveries,
          status: [],
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_DELIVERIES_DATA:
      return {
        ...state,
        fetchDeliveries: {
          ...state.fetchDeliveries,
          status: payload.content,
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELIVERIES_DATA:
      return {
        ...state,
        fetchDeliveries: {
          ...state.fetchDeliveries,
          status: [],
          loading: false,
          error: null,
        },
      };
    /* */
    case type.REQUEST_GOAL_DATA:
      return {
        ...state,
        fetchGoals: {
          ...state.fetchGoals,
          status: [],
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_GOAL_DATA:
      return {
        ...state,
        fetchGoals: {
          ...state.fetchGoals,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_GOAL_DATA:
      return {
        ...state,
        fetchGoals: {
          ...state.fetchGoals,
          status: payload.progress,
          loading: false,
          error: null,
        },
      };
    case type.RESET_GOAL_DATA:
      return {
        ...state,
        fetchGoals: {
          ...state.fetchGoals,
          status: null,
          loading: false,
          error: null,
        },
      };
    /** */
    case type.SET_GOAL_TYPE:
      return {
        ...state,
        fetchGoals: {
          ...state.fetchGoals,
          type: payload.goal,
        },
      };
    case type.RESET_GOAL_TYPE:
      return {
        ...state,
        fetchGoals: {
          ...state.fetchGoals,
          type: null,
        },
      };
    /** */
    case type.REQUEST_CREATE_NEW_GOAL:
      return {
        ...state,
        addGoal: {
          ...state.addGoal,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_CREATE_NEW_GOAL:
      return {
        ...state,
        addGoal: {
          ...state.addGoal,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_CREATE_NEW_GOAL:
      return {
        ...state,
        addGoal: {
          ...state.addGoal,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_CREATE_NEW_GOAL:
      return {
        ...state,
        addGoal: {
          ...state.addGoal,
          status: null,
          loading: false,
          error: null,
        },
      };
    /** */
    case type.REQUEST_DELETE_SINGLE_GOAL:
      return {
        ...state,
        deleteGoal: {
          ...state.deleteGoal,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_DELETE_SINGLE_GOAL:
      return {
        ...state,
        deleteGoal: {
          ...state.deleteGoal,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_DELETE_SINGLE_GOAL:
      return {
        ...state,
        deleteGoal: {
          ...state.deleteGoal,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_DELETE_SINGLE_GOAL:
      return {
        ...state,
        deleteGoal: {
          ...state.deleteGoal,
          status: null,
          loading: false,
          error: null,
        },
      };
    /** */
    case type.REQUEST_UPDATE_SINGLE_GOAL:
      return {
        ...state,
        updateGoal: {
          ...state.updateGoal,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_UPDATE_SINGLE_GOAL:
      return {
        ...state,
        updateGoal: {
          ...state.updateGoal,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_SINGLE_GOAL:
      return {
        ...state,
        updateGoal: {
          ...state.updateGoal,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_UPDATE_SINGLE_GOAL:
      return {
        ...state,
        updateGoal: {
          ...state.updateGoal,
          status: null,
          loading: false,
          error: null,
        },
      };
    /** */
    case type.SET_ACTIVE_UPDATE_GOAL:
      return {
        ...state,
        activeUpdateGoal: payload.payload,
      };
    case type.RESET_ACTIVE_UPDATE_GOAL:
      return {
        ...state,
        activeUpdateGoal: {
          ...state.activeUpdateGoal,
          amount: null,
          start: null,
          end: null,
        },
      };
    default:
      return state;
  }
};
